/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ActivityFieldCategories {
	Basic = "Basic",
	Attendees = "Attendees",
	ServiceAreas = "ServiceAreas",
	LeaderProcesses = "LeaderProcesses",
	Outlook = "Outlook",
	Linking = "Linking",
	Description = "Description",
	VisibilityAndInforming = "VisibilityAndInforming",
}
